import { useTranslation } from 'react-i18next';
import { ApiError } from '@lumlab/platform-product/web';
import { ErrorAlert, Notice } from '@lumlab/platform-ui';
import { analysisCommandConflict } from '../contract/analysis-cases.ts';

export function AnalysisErrorAlert({ error }: { error: unknown }) {
    const { t } = useTranslation();
    const parsed = analysisCommandConflict.safeParse(error instanceof ApiError ? error.body : undefined);
    if (!parsed.success) return <ErrorAlert error={error} />;
    const { reason, conflicts } = parsed.data.error;
    return (
        <Notice tone="danger">
            <p>{t(`tenders.arbitration.errors.${reason}`)}</p>
            {conflicts?.map((conflict) => (
                <p className="break-all" key={conflict.conflictKey}>
                    {t('tenders.arbitration.ruleConflictDetails', {
                        key: conflict.conflictKey,
                        ids: conflict.revisionIds.join(', '),
                    })}
                </p>
            ))}
        </Notice>
    );
}
